import commaNumber from 'comma-number'

import { CURRENCY_DELIMITER } from '../constants/app'

const formatTicks = (num) => {
  if (num === undefined) {
    return ''
  }
  return commaNumber(num, CURRENCY_DELIMITER)
}

const toLowerCamelCase = (s) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}

const trim = (string) => {
  return string ? string.trim() : ''
}

const toUpper = (text) => {
  return text ? text.toUpperCase() : ''
}

const toLower = (text) => {
  return text ? text.toLowerCase() : ''
}

export { formatTicks, toLowerCamelCase, trim, toUpper, toLower }
